import script from "./DeleteSSOConnectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteSSOConnectionModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteSSOConnectionModal.vue?vue&type=style&index=0&id=3bc29290&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc29290"]])

export default __exports__